import { inject, injectable } from 'inversify';
import type { IViewPortManager } from '../../interfaces';
import type { IIndicationsFactory } from './Indications.factory';
import { TYPES } from './iocTypes';
import { ToolsManager } from './ToolsManager';
import type { ToolStateStore } from './ToolStateStore';

@injectable()
export class ToolsManagerFactory {
  private _toolStateStore: ToolStateStore;

  private _indicationsFactory: IIndicationsFactory;

  public constructor(
    @inject(TYPES.ToolStateStore) toolStateStore: ToolStateStore,
    @inject(TYPES.IIndicationsFactory) indicationsFactory: IIndicationsFactory
  ) {
    this._toolStateStore = toolStateStore;
    this._indicationsFactory = indicationsFactory;
  }

  public createToolsManager(vpms: Array<IViewPortManager>): ToolsManager {
    return new ToolsManager(this._toolStateStore, this._indicationsFactory, vpms);
  }
}
